// @flow
// $FlowFixMe
import React, { useState, useEffect, useRef } from 'react';
import IconLabel from './IconLabel';

import styles from './CopyButton.css';
import classNames from 'classnames';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  copied: {
    id: 'copy-button.copied',
    defaultMessage: 'Copied',
  },
});

type OwnProps = {
  onClick: Function,
};

type Props = OwnProps & { intl: IntlShape };

const CopyButton = ({ onClick, intl }: Props) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef();

  const onButtonClick = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    onClick();
    setCopied(true);

    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <button
      onClick={onButtonClick}
      className={classNames('c-btn', styles.copyButton, {
        [styles.copied]: copied,
      })}
      aria-label={copied ? intl.formatMessage(messages.copied) : ''}
    >
      {copied ? (
        <IconLabel name="check" />
      ) : (
        <React.Fragment>
          <IconLabel name="copy" size="default" />
          <FormattedMessage id="copy" defaultMessage="Copy" />
        </React.Fragment>
      )}
    </button>
  );
};

export default injectIntl(CopyButton);
